module.exports = __webpack_public_path__ + "media/images/home/boxes/unlimited_students-06c7bb09059af401960fc7010e0ed633.svg";